import { Libraries } from '@googlemaps/js-api-loader';

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY || '';
export const GOOGLE_MAPS_VERSION = 'weekly';
export const GOOGLE_MAPS_LIBRARIES: Libraries = ['geocoding', 'places', 'geometry'];
